import type UserService from '../user.service';
import type LoanService from '../../loan/loan.service';
import type ActionRequestService from 'shared/services/action-request.service';

export class KpUserListPageService {
    public static serviceName = 'kpUserListPageService';

    /*@ngInject*/
    constructor(private loanService: LoanService,
                private userService: UserService,
                private actionRequestService: ActionRequestService) {
    }

    public async showReturningForm() {
        await this.loanService.showReturningForm();
    }

    public async createNewPersonReader() {
        return this.userService.createNewPersonReader();
    }

    public async createNewEditorPerson() {
        return this.userService.createNewEditorPerson();
    }

    public async createNewLibraryReader() {
        return this.userService.createNewLibraryReader();
    }

    public async createNewInstitution() {
        return this.userService.createNewInstitution();
    }

    public async createNewSoftware() {
        return this.userService.createNewSoftware();
    }

    public async createNewFamily() {
        return this.userService.createNewFamily();
    }

    public async createNewRelation() {
        return this.userService.createNewRelation();
    }

    public async printTransactions() {
        await this.actionRequestService.action('/api/transaction-prints', 'post', {});
    }
}